import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EMPTY, IN_PROGRESS, DONE, ERROR } from "constants/Status";
import { IAccount } from "types/account";
import { getAccount } from "selectors";
import { AccountActionsCreator } from "../../actions/accountActionsCreator";
import { setAccountNumber, resetAccountState } from "actions/accountActions";
import { IValidationHeaders } from "types/validationHeaders";

export interface IUseAccount {
    getAccount: (instanceId: string, validationFields: unknown) => IAccount;
    loadAccount: (validationHeaders: IValidationHeaders, accountNumber:string, validationFields: unknown) => Promise<void>;
    resetAccount: () => void;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (): IUseAccount => {
    const dispatch = useDispatch();
    const getAccountAction = AccountActionsCreator.getAccount;
    const account = useSelector(getAccount);
    const [loadAccountStatus, setLoadAccountStatus] = useState(EMPTY);

    
    const loadAccountRequest = (validationHeaders: IValidationHeaders, validationFields: unknown) =>

    new Promise((resolve, reject) =>
        dispatch(getAccountAction(validationHeaders, validationFields, resolve, reject))
        );
    const loadAccount = async (validationHeaders: IValidationHeaders, accountNumber: string, validationFields: unknown) => {
        dispatch(setAccountNumber(accountNumber));
        setLoadAccountStatus(IN_PROGRESS);
        try {
            await loadAccountRequest(validationHeaders, validationFields);
            setLoadAccountStatus(DONE);
        } catch (error) {
            setLoadAccountStatus(ERROR);
            throw error;
        }
    };

    const resetAccount = () => {
        dispatch(resetAccountState());
    }

    return {
        loadAccount,
        getAccount: () => account,
        resetAccount,
    };
};